import { mealVouchersApi, type mealVouchersInternalApi } from 'app/src/services/welfareportal'

import { DefaultBodyType, http, HttpResponse } from 'msw'

const apiBaseUrl = './buonipasto/api/v1'

const getUnits = http.get<object, DefaultBodyType, mealVouchersApi.UnitsResponse>(apiBaseUrl + '/units', () => {
  const units: mealVouchersApi.UnitsResponse = {
    data: [
      {
        id: 4,
        store_name: 'BAR Sport 1',
        business_name: 'Esercente 2',
        email: 'zombie_4_3@toduba.it',
        address: 'Via Giuseppe Luigi Lagrange 7',
        city: 'Torino',
        cap: '10123',
        province: 'TO',
        nation: 'IT',
        geo_x: 45.0668,
        geo_y: 7.683773,
        distance: 183.72,
        trustlines: ['BCP1V0630', 'BCP1V0480', 'BCP1V0800'],
        subcategory_id: 1,
        subcategory_name: 'Bar / Club / Caffé',
        description: '',
        opening_hours: {
          FRI: [
            {
              from: '06:00',
              to: '21:00',
            },
          ],
          MON: [
            {
              from: '06:00',
              to: '21:00',
            },
          ],
          SAT: [
            {
              from: '06:00',
              to: '21:00',
            },
          ],
          SUN: [],
          THU: [
            {
              from: '06:00',
              to: '21:00',
            },
          ],
          TUE: [],
          WED: [
            {
              from: '06:00',
              to: '21:00',
            },
          ],
        },
        is_on_holiday: false,
        contact_email: '',
        contact_phone: '+390118888888',
        unit_owner_id: 3,
        social_accounts: [],
        pictures: {
          pin: 'https://dev.assets.toduba.it/toduba/pictures/merchantscategories/1.png',
          profile:
            'https://dev.assets.toduba.it/toduba/pictures/merchants/46d18ac5cc17970c3a8e9df882bff74df9a09ce1e9447efa437bb1c5e5250ca7.png',
        },
      },
      {
        id: 15,
        store_name: 'Merchant 1 GDO Argentea',
        business_name: 'GDO POS ARGENTEA',
        email: 'zombie_15_3@toduba.it',
        address: 'Via Roma 3',
        city: 'Torino',
        cap: '',
        province: 'TO',
        nation: 'IT',
        geo_x: 45.070531,
        geo_y: 7.684468,
        distance: 263.8,
        trustlines: ['BCP1V0630', 'BCP1V0800', 'BCP1V0480'],
        subcategory_id: 18,
        subcategory_name: 'Supermercato / Alimentari',
        pos_vendor_id: 1,
        description: '',
        opening_hours: {
          FRI: [
            {
              from: '10:00',
              to: '20:00',
            },
          ],
          MON: [
            {
              from: '10:00',
              to: '20:00',
            },
          ],
          SAT: [
            {
              from: '10:00',
              to: '20:00',
            },
          ],
          SUN: [
            {
              from: '10:00',
              to: '20:00',
            },
          ],
          THU: [
            {
              from: '10:00',
              to: '20:00',
            },
          ],
          TUE: [
            {
              from: '10:00',
              to: '20:00',
            },
          ],
          WED: [],
        },
        is_on_holiday: false,
        contact_email: '',
        contact_phone: '+390117080372',
        unit_owner_id: 14,
        social_accounts: [
          {
            link: 'https://www.bershka.com/it',
            type: 'facebook',
          },
        ],
        pictures: {
          pin: 'https://dev.assets.toduba.it/toduba/pictures/merchantscategories/6.png',
          profile:
            'https://dev.assets.toduba.it/toduba/pictures/merchants/88fcba08b7b2c7e69e15f7990349fd3c82a0a6a584c41a62216ef3d0b50d735b.png',
        },
      },
      {
        id: 18,
        store_name: 'Merchant 1 GDO Ncr',
        business_name: 'GDO POS NCR',
        email: 'zombie_18_3@toduba.it',
        address: 'Via Lagrange 34',
        city: 'Torino',
        cap: '',
        province: 'TO',
        nation: 'IT',
        geo_x: 45.06431,
        geo_y: 7.681414,
        distance: 470.32,
        trustlines: ['BCP1V0800', 'BCP1V0480', 'BCP1V0630'],
        subcategory_id: 18,
        subcategory_name: 'Supermercato / Alimentari',
        pos_vendor_id: 4,
        description: '',
        opening_hours: {
          FRI: [],
          MON: [],
          SAT: [],
          SUN: [],
          THU: [],
          TUE: [],
          WED: [],
        },
        is_on_holiday: false,
        contact_email: '',
        contact_phone: '',
        unit_owner_id: 17,
        social_accounts: [],
        pictures: {
          pin: 'https://dev.assets.toduba.it/toduba/pictures/merchantscategories/6.png',
          profile:
            'https://dev.assets.toduba.it/toduba/pictures/merchants/6a5180aa20259ea0c0659717a1afa78326e8fe39bd27fd64371ef895d241fa50.png',
        },
      },
      {
        id: 58,
        store_name: 'Ristorante E06',
        business_name: 'Esercente 8',
        email: 'zombie_58_3@toduba.it',
        address: 'Piazza Carlo Felice 5',
        city: 'Torino',
        cap: '10123',
        province: 'TO',
        nation: 'IT',
        geo_x: 45.064312,
        geo_y: 7.680329,
        distance: 500.3,
        trustlines: ['BCP1V0480', 'BCP1V0630', 'BCP1V0800'],
        subcategory_id: 2,
        subcategory_name: 'Ristorante / Fast Food',
        description: '',
        opening_hours: {
          FRI: [
            {
              from: '10:00',
              to: '21:00',
            },
          ],
          MON: [
            {
              from: '10:00',
              to: '20:00',
            },
          ],
          SAT: [
            {
              from: '10:00',
              to: '21:00',
            },
          ],
          SUN: [
            {
              from: '10:00',
              to: '21:00',
            },
          ],
          THU: [
            {
              from: '10:00',
              to: '20:00',
            },
          ],
          TUE: [
            {
              from: '10:00',
              to: '20:00',
            },
          ],
          WED: [
            {
              from: '10:00',
              to: '20:00',
            },
          ],
        },
        is_on_holiday: false,
        contact_email: '',
        contact_phone: '+39011375015',
        unit_owner_id: 53,
        social_accounts: [
          {
            link: 'https://www.instagram.com/riecco_portanuova?igsh=MTF0czdrZDl5ejVqeg==',
            type: 'facebook',
          },
        ],
        pictures: {
          pin: 'https://dev.assets.toduba.it/toduba/pictures/merchantscategories/1.png',
          profile:
            'https://dev.assets.toduba.it/toduba/pictures/merchants/8c45108c7be94dd3b6f6825f7eb3b8a129adc6ac75eaa71856aec2cf1def8b20.png',
        },
      },
      {
        id: 8,
        store_name: 'RISTORANTE MARE 2',
        business_name: 'Esercente 3',
        email: 'zombie_8_3@toduba.it',
        address: 'Piazza Giambattista Bodoni 9',
        city: 'Torino',
        cap: '10123',
        province: 'TO',
        nation: 'IT',
        geo_x: 45.063213,
        geo_y: 7.683251,
        distance: 574.2,
        trustlines: ['BCP1V0630', 'BCP1V0800', 'BCP1V0480'],
        subcategory_id: 2,
        subcategory_name: 'Ristorante / Fast Food',
        description: '',
        opening_hours: {
          FRI: [],
          MON: [],
          SAT: [],
          SUN: [],
          THU: [],
          TUE: [],
          WED: [],
        },
        is_on_holiday: false,
        contact_email: '',
        contact_phone: '',
        unit_owner_id: 6,
        social_accounts: [],
        pictures: {
          pin: 'https://dev.assets.toduba.it/toduba/pictures/merchantscategories/1.png',
          profile:
            'https://dev.assets.toduba.it/toduba/pictures/merchants/88fcba08b7b2c7e69e15f7990349fd3c82a0a6a584c41a62216ef3d0b50d735b.png',
        },
      },
      {
        id: 57,
        store_name: 'Ristorante E04',
        business_name: 'Esercente 8',
        email: 'zombie_57_3@toduba.it',
        address: 'Via Nizza 5',
        city: 'Torino',
        cap: '10100',
        province: 'TO',
        nation: 'IT',
        geo_x: 45.061433,
        geo_y: 7.679613,
        distance: 818.14,
        trustlines: ['BCP1V0480', 'BCP1V0630', 'BCP1V0800'],
        subcategory_id: 2,
        subcategory_name: 'Ristorante / Fast Food',
        description: '',
        opening_hours: {
          FRI: [
            {
              from: '12:00',
              to: '14:30',
            },
            {
              from: '19:30',
              to: '22:30',
            },
          ],
          MON: [
            {
              from: '12:00',
              to: '14:30',
            },
            {
              from: '19:30',
              to: '22:30',
            },
          ],
          SAT: [
            {
              from: '12:00',
              to: '14:30',
            },
            {
              from: '19:30',
              to: '22:30',
            },
          ],
          SUN: [
            {
              from: '12:00',
              to: '14:30',
            },
            {
              from: '19:30',
              to: '22:30',
            },
          ],
          THU: [
            {
              from: '12:00',
              to: '14:30',
            },
            {
              from: '19:30',
              to: '22:30',
            },
          ],
          TUE: [
            {
              from: '12:00',
              to: '14:30',
            },
            {
              from: '19:30',
              to: '22:30',
            },
          ],
          WED: [
            {
              from: '12:00',
              to: '14:30',
            },
            {
              from: '19:30',
              to: '22:30',
            },
          ],
        },
        is_on_holiday: false,
        contact_email: '',
        contact_phone: '+393514639707',
        unit_owner_id: 53,
        social_accounts: [],
        pictures: {
          pin: 'https://dev.assets.toduba.it/toduba/pictures/merchantscategories/1.png',
          profile:
            'https://dev.assets.toduba.it/toduba/pictures/merchants/8c45108c7be94dd3b6f6825f7eb3b8a129adc6ac75eaa71856aec2cf1def8b20.png',
        },
      },
      {
        id: 21,
        store_name: 'Merchant 1 GDO Wincor Diebold Nixdorf',
        business_name: 'GDO POS Wincor Diebold Nixdorf',
        email: 'zombie_21_3@toduba.it',
        address: 'Via Monterosa 16',
        city: 'Torino',
        cap: '',
        province: 'TO',
        nation: 'IT',
        geo_x: 45.087518,
        geo_y: 7.693915,
        distance: 2292.75,
        trustlines: ['BCP1V0800', 'BCP1V0480', 'BCP1V0630'],
        subcategory_id: 18,
        subcategory_name: 'Supermercato / Alimentari',
        pos_vendor_id: 2,
        description: '',
        opening_hours: {
          FRI: [],
          MON: [],
          SAT: [],
          SUN: [],
          THU: [],
          TUE: [],
          WED: [],
        },
        is_on_holiday: false,
        contact_email: '',
        contact_phone: '',
        unit_owner_id: 20,
        social_accounts: [],
        pictures: {
          pin: 'https://dev.assets.toduba.it/toduba/pictures/merchantscategories/6.png',
          profile:
            'https://dev.assets.toduba.it/toduba/pictures/merchants/8dc7f59b7dfdb8751e31b8a65fc64b09a0784bdc1189a578f02392877fc8f31c.png',
        },
      },
      {
        id: 49,
        store_name: 'Ristorante la Lanterna',
        business_name: 'Esercente 7',
        email: 'zombie_49_3@toduba.it',
        address: 'Via Ugo Foscolo 5',
        city: 'Torino',
        cap: '10126',
        province: 'TO',
        nation: 'IT',
        geo_x: 45.048132,
        geo_y: 7.674309,
        distance: 2353.68,
        trustlines: ['BCP1V0480', 'BCP1V0630', 'BCP1V0800'],
        subcategory_id: 2,
        subcategory_name: 'Ristorante / Fast Food',
        description: '',
        opening_hours: {
          FRI: [
            {
              from: '10:30',
              to: '15:00',
            },
          ],
          MON: [
            {
              from: '10:30',
              to: '15:00',
            },
          ],
          THU: [
            {
              from: '10:30',
              to: '15:00',
            },
          ],
          TUE: [
            {
              from: '10:30',
              to: '15:00',
            },
          ],
          WED: [
            {
              from: '10:30',
              to: '15:00',
            },
          ],
        },
        is_on_holiday: false,
        contact_email: '',
        contact_phone: '+3901119509103',
        unit_owner_id: 37,
        social_accounts: [],
        pictures: {
          pin: 'https://dev.assets.toduba.it/toduba/pictures/merchantscategories/1.png',
          profile:
            'https://dev.assets.toduba.it/toduba/pictures/merchants/d5ceb72ff726d6a8bdeb522bd9c0a10a60c0cfd58e456cf63da0d5838e1aafb3.png',
        },
      },
      {
        id: 25,
        store_name: 'Merchant 1 GDO Konvergence',
        business_name: 'GDO POS Konvergence',
        email: 'zombie_25_3@toduba.it',
        address: 'Via Ticino 2',
        city: 'Torino',
        cap: '',
        province: 'TO',
        nation: 'IT',
        geo_x: 45.095759,
        geo_y: 7.682515,
        distance: 3045.22,
        trustlines: ['BCP1V0800', 'BCP1V0480', 'BCP1V0630'],
        subcategory_id: 18,
        subcategory_name: 'Supermercato / Alimentari',
        pos_vendor_id: 6,
        description: '',
        opening_hours: {
          FRI: [
            {
              from: '08:00',
              to: '12:00',
            },
            {
              from: '13:00',
              to: '17:00',
            },
          ],
          MON: [
            {
              from: '08:00',
              to: '12:00',
            },
            {
              from: '13:00',
              to: '17:00',
            },
          ],
          SAT: [
            {
              from: '08:00',
              to: '12:00',
            },
            {
              from: '13:00',
              to: '17:00',
            },
          ],
          SUN: [
            {
              from: '08:00',
              to: '12:00',
            },
            {
              from: '13:00',
              to: '17:00',
            },
          ],
          THU: [
            {
              from: '08:00',
              to: '12:00',
            },
            {
              from: '13:00',
              to: '17:00',
            },
          ],
          TUE: [
            {
              from: '08:00',
              to: '12:00',
            },
            {
              from: '13:00',
              to: '17:00',
            },
          ],
          WED: [
            {
              from: '08:00',
              to: '12:00',
            },
            {
              from: '13:00',
              to: '17:00',
            },
          ],
        },
        is_on_holiday: false,
        contact_email: '',
        contact_phone: '+390112204049',
        unit_owner_id: 24,
        social_accounts: [
          {
            link: 'https://www.generalvending.it/',
            type: 'facebook',
          },
        ],
        pictures: {
          pin: 'https://dev.assets.toduba.it/toduba/pictures/merchantscategories/6.png',
          profile:
            'https://dev.assets.toduba.it/toduba/pictures/merchants/868e937fc4f62de8122e08f915be7e527c1b16035c288741c8285741146cca8d.png',
        },
      },
      {
        id: 7,
        store_name: 'RISTORANTE MARE 1',
        business_name: 'Esercente 3',
        email: 'zombie_7_3@toduba.it',
        address: 'Corso Grosseto 45',
        city: 'Torino',
        cap: '10147',
        province: 'TO',
        nation: 'IT',
        geo_x: 45.103431,
        geo_y: 7.688049,
        distance: 3917.6,
        trustlines: ['BCP1V0630', 'BCP1V0480', 'BCP1V0800'],
        subcategory_id: 2,
        subcategory_name: 'Ristorante / Fast Food',
        description: '',
        opening_hours: {
          FRI: [],
          MON: [],
          SAT: [],
          SUN: [],
          THU: [],
          TUE: [],
          WED: [],
        },
        is_on_holiday: false,
        contact_email: '',
        contact_phone: '',
        unit_owner_id: 6,
        social_accounts: [],
        pictures: {
          pin: 'https://dev.assets.toduba.it/toduba/pictures/merchantscategories/1.png',
          profile:
            'https://dev.assets.toduba.it/toduba/pictures/merchants/88fcba08b7b2c7e69e15f7990349fd3c82a0a6a584c41a62216ef3d0b50d735b.png',
        },
      },
    ],
    meta: {
      total_count: 13,
    },
  }

  return HttpResponse.json(units)
})

const getUnitPicture = http.get<object, DefaultBodyType, mealVouchersApi.UnitPictures>(
  apiBaseUrl + '/units/:unitId/pictures',
  () => {
    const getUnitPicture: mealVouchersApi.UnitPictures = {
      pin: 'http://upload.wikimedia.org/wikipedia/commons/thumb/8/82/Logo_semplice_Poste_Italiane.svg/960px-Logo_semplice_Poste_Italiane.svg.png',
      profile:
        'http://upload.wikimedia.org/wikipedia/commons/thumb/8/82/Logo_semplice_Poste_Italiane.svg/960px-Logo_semplice_Poste_Italiane.svg.png',
    }

    return HttpResponse.json(getUnitPicture)
  },
)

const createOTP = http.post<object, DefaultBodyType, mealVouchersApi.PosOtpCreateResponse>(
  apiBaseUrl + '/companies/97103880585/users/BNCMRA70A20H501B/posOtps',
  async () => {
    const createOTPResponse: mealVouchersApi.PosOtpCreateResponse = {
      otp: '9228701',
      created_at: Date.now(),
      validity: 100,
    }

    await new Promise((resolve) => setTimeout(resolve, 500))

    return HttpResponse.json(createOTPResponse)
  },
)

const getOtp = http.get<object, DefaultBodyType, mealVouchersApi.PosOtpResponse | mealVouchersApi.UserPosOtpGetError>(
  apiBaseUrl + '/companies/97103880585/users/BNCMRA70A20H501B/posOtps/:otp',
  () => {
    const response: mealVouchersApi.PosOtpResponse = [
      {
        transaction_id: 'txn_123456789',
        merchant_id: 5,
        user_id: 12345,
        ticket_cost: 25.5,
        otp: '9228701',
        valid_to: '2024-12-31T23:59:59Z',
        pos_vendor_id: 5,
        assets: {
          asset_code_1: 2,
          asset_code_2: 1,
        },
      },
    ]

    // return HttpResponse.json(response)
    if (Math.random() < 0.3) {
      return HttpResponse.json(
        { status: 404, payload: { code: 'REQUESTED_OTP_ALREADY_PROCESSED', message: 'OTP not found' } },
        { status: 404 },
      )
    } else {
      return HttpResponse.json(response)
    }
  },
)

const createTransaction = http.post<object, DefaultBodyType>(
  apiBaseUrl + '/companies/97103880585/users/BNCMRA70A20H501B/transactions',
  async () => {
    await new Promise((resolve) => setTimeout(resolve, 500))

    return HttpResponse.json({})
  },
)

const getBalances = http.get<object, DefaultBodyType, mealVouchersApi.UserBalances>(
  apiBaseUrl + '/companies/97103880585/users/BNCMRA70A20H501B/balances',
  async () => {
    const getBalancesResponse: mealVouchersApi.UserBalances = {
      data: {
        asset_code_1: {
          value: 8.5,
          amount: 10,
          total_value: 85,
          is_purchasable: true,
          is_active: true,
          can_purchase_cards: true,
          category_id: 'BP',
        },
        asset_code_2: {
          value: 25,
          amount: 2,
          total_value: 50,
          is_purchasable: true,
          is_active: true,
          can_purchase_cards: false,
          category_id: 'BS',
          next_expirations: [
            {
              date: '2025-12-31',
              amount: 4,
            },
          ],
        },
      },
      meta: {
        total_count: 12,
      },
    }

    await new Promise((resolve) => setTimeout(resolve, 100))
    return HttpResponse.json(getBalancesResponse)
  },
)

const getFavourites = http.get<object, DefaultBodyType, mealVouchersInternalApi.UserFavorites>(
  apiBaseUrl + '/companies/97103880585/users/BNCMRA70A20H501B/favorites',
  () => {
    const getFavouritesResponse: mealVouchersInternalApi.UserFavorites = [
      {
        id: 1,
        store_name: 'Supermercato ABC',
        email: 'user@example.com',
        address: 'Piazza Navona',
        city: 'Roma',
        cap: '00135',
        province: 'string',
        geo_x: 12.4731686,
        geo_y: 41.8992632,
        subcategory_id: 0,
        trustlines: ['BP_MEALS', 'GIFT_CARDS', 'BS_SHOPPING'],
        pos_vendor_id: 5,
        products_vendor: {
          id: 0,
          name: 'string',
        },
        giftcards_brand: {
          id: 0,
          name: 'string',
          behaviourTypeId: 0,
        },
        description: 'string',
        opening_hours: {
          LUN: [
            {
              from: '09:00:00',
              to: '12:30:00',
            },
            {
              from: '15:00:00',
              to: '19:00:00',
            },
          ],
          MAR: [
            {
              from: '09:00:00',
              to: '19:00:00',
            },
          ],
        },
        is_on_holiday: true,
        contact_email: 'user@example.com',
        contact_phone: '+3906565512346',
        social_accounts: [
          {
            type: 'facebook',
            link: 'https://example.com/',
          },
        ],
        pictures: {
          pin: 'images/pin.png',
          profile: 'images/pin.png',
        },
      },
      {
        id: 2,
        store_name: 'Negozio XYZ',
        email: 'user@example.com',
        address: 'Piazza della Rotonda',
        city: 'Roma',
        cap: '00135',
        province: 'string',
        geo_x: 12.4922,
        geo_y: 41.8902,
        subcategory_id: 0,
        trustlines: ['BP_MEALS', 'GIFT_CARDS', 'BS_SHOPPING'],
        pos_vendor_id: 0,
        products_vendor: {
          id: 0,
          name: 'string',
        },
        giftcards_brand: {
          id: 0,
          name: 'string',
          behaviourTypeId: 0,
        },
        description: 'string',
        opening_hours: {
          LUN: [
            {
              from: '09:00:00',
              to: '12:30:00',
            },
            {
              from: '15:00:00',
              to: '19:00:00',
            },
          ],
          MAR: [
            {
              from: '09:00:00',
              to: '19:00:00',
            },
          ],
        },
        is_on_holiday: true,
        contact_email: 'user@example.com',
        contact_phone: '+3906565512346',
        social_accounts: [
          {
            type: 'facebook',
            link: 'https://example.com/',
          },
        ],
        pictures: {
          pin: 'images/pin.png',
          profile: 'images/pin.png',
        },
      },
    ]
    return HttpResponse.json(getFavouritesResponse)
  },
)

const addFavourite = http.post<object, DefaultBodyType>(
  apiBaseUrl + '/companies/97103880585/users/BNCMRA70A20H501B/favorites',
  () => {
    return HttpResponse.json({})
  },
)

const deleteFavourite = http.delete<object, DefaultBodyType>(
  apiBaseUrl + '/companies/97103880585/users/BNCMRA70A20H501B/favorites/:unitId',
  () => {
    return HttpResponse.json({})
  },
)

const getTransactions = http.get<object, DefaultBodyType, mealVouchersApi.TransactionsResponse>(
  apiBaseUrl + '/companies/97103880585/users/BNCMRA70A20H501B/transactions',
  () => {
    const getFavouritesResponse: mealVouchersApi.TransactionsResponse = [
      {
        datetime: '2025-10-23T07:16:03.028Z',
        type: 'out',
        from: 'Carrefour Market',
        from_id: 0,
        amount: 16,
        operations: [
          {
            op_id: 0,
            asset: 'asset_code_1',
            value: 8,
            count: 2,
            total_value: 16,
            to: 'string',
            to_id: 0,
          },
        ],
        hash: 'string',
      },
      {
        datetime: '2025-10-23T07:16:03.028Z',
        type: 'out',
        from: 'Panorama Supermercato',
        from_id: 4.8,
        amount: 24,
        operations: [
          {
            op_id: 0,
            asset: 'asset_code_1',
            value: 8,
            count: 3,
            total_value: 24,
            to: 'string',
            to_id: 0,
          },
        ],
        hash: 'string',
      },
      {
        datetime: '2025-10-23T07:16:03.028Z',
        type: 'out',
        from: 'Todis',
        from_id: 4.8,
        amount: 56,
        operations: [
          {
            op_id: 0,
            asset: 'asset_code_2',
            value: 8,
            count: 3,
            total_value: 24,
            to: 'string',
            to_id: 0,
          },
          {
            op_id: 0,
            asset: 'asset_code_2',
            value: 8,
            count: 4,
            total_value: 32,
            to: 'string',
            to_id: 0,
          },
        ],
        hash: 'string',
      },
      {
        datetime: '2025-10-23T07:16:03.028Z',
        type: 'in',
        from: 'XXXX',
        from_id: 4.8,
        amount: 168,
        operations: [
          {
            op_id: 0,
            asset: 'asset_code_2',
            value: 8,
            count: 21,
            total_value: 168,
            to: 'string',
            to_id: 0,
          },
        ],
        hash: 'string',
      },
      {
        datetime: '2025-02-03T07:16:03.028Z',
        type: 'in',
        from: 'XXXX',
        from_id: 4.8,
        amount: 168,
        operations: [
          {
            op_id: 0,
            asset: 'asset_code_1',
            value: 8,
            count: 21,
            total_value: 168,
            to: 'string',
            to_id: 0,
          },
        ],
        hash: 'string',
      },
    ]
    return HttpResponse.json(getFavouritesResponse)
  },
)

export const mealvouchersHandlers = [
  getUnits,
  getUnitPicture,
  createOTP,
  createTransaction,
  getBalances,
  getFavourites,
  addFavourite,
  deleteFavourite,
  getTransactions,
  getOtp,
]
